import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GeneralReportOrganizationBillingComponent } from "./GeneralReportOrganizationBillingComponent";
import { ReportByCoachOrganizationBillingComponent } from "./ReportByCoachOrganizationBillingComponent";

export const OrganizationBillingReportComponent = ({
  report,
  isCurrentMonth,
  webAppTheme,
}) => {
  const { t } = useTranslation("dashboard");
  const [tabState, setTabState] = useState("general-tab"); //state to control the active tab
  const { reportByCoach, generalReport, totalAmount } = report;
  const { athletes = [] } = generalReport;

  /**
   * Change div's content
   * @param {*} tab
   */
  const handleActiveTab = (tab) => {
    setTabState(tab);
  };

  return (
    <>
      <div
        className={
          tabState === "coach-tab"
            ? "organization-billing-report-header mb-7"
            : "organization-billing-report-header"
        }
      >
        <nav role="tablist">
          <a
            id="general-tab"
            onClick={() => handleActiveTab("general-tab")}
            aria-current={tabState === "general-tab" ? true : undefined}
          >
            {t("organizationBillingReport.coachBilling")}
          </a>
          <a
            id="by coach-tab"
            onClick={() => handleActiveTab("coach-tab")}
            aria-current={tabState === "coach-tab" ? true : undefined}
          >
            {t("organizationBillingReport.billingPerCoach")}
          </a>
        </nav>
        <a
          data-button-type="outline"
          role="button"
          href="/actions/refresh?modal[type]=summary-organization-billing"
        >
          {t("organizationBillingReport.summary")}
        </a>
      </div>

      {tabState === "general-tab" ? (
        <GeneralReportOrganizationBillingComponent athletes={athletes} />
      ) : (
        <ReportByCoachOrganizationBillingComponent
          reportByCoach={reportByCoach}
          webAppTheme={webAppTheme}
        />
      )}
      {tabState === "coach-tab" && <hr />}
      <div className="total">
        <div className="totalValue">
          {isCurrentMonth && (
            <span>{t("coachBillingReport.estimated")} </span>
          )}
          {t("coachBillingReport.total")}:{" "}
          <span className="clipped font-semibold">{`$${totalAmount}`}</span>
        </div>
      </div>
    </>
  );
};
